<template>
  <div id="page">
    <template v-if="detail">
      <Detail :item="detail"></Detail>
    </template>
    <template v-else>
      <div class="searcher"><input v-model="search" type="text" /></div>
      <div class="list">
        <div
          v-for="(item, index) in results"
          class="item"
          :key="item.id"
          @click="select(item.id)"
        >
          <div
            class="image"
            :style="{ backgroundImage: 'url(' + item.img + ')' }"
          ></div>
          <div class="content">
            <div class="title">{{ item.name }}</div>
            <div class="city">{{ item.city }}</div>
          </div>
        </div>
      </div>
    </template>

    <template v-if="sponsor">
        <img
        class="sponsor"
        :src="sponsor"
        loading="lazy"
        height="300"
      />
    </template>
  </div>
</template>

<script>
import { Api } from "@/core/api.js";
import Detail from "@/components/domain/facilities/detail";
const api = new Api();

export default {
  name: "Facilities",
  components: {
    Detail
  },
  data() {
    return {
      search: "",
      detailId: false
    };
  },
  computed: {
    data() {
      return this.$store.getters["facilities/getList"]();
    },
    results() {
      var results = {};
      var data = this.data;
      var searchInput = cleanString(this.search.trim().toLowerCase());

      if (searchInput == "") return data;

      for (var idx in data) {
        var item = data[idx];

        var name = cleanString(item.name.trim().toLowerCase());

        if (searchInput != "") {
          const searchRegex = new RegExp(searchInput, "g");
          if (name.match(searchRegex)) {
            results[item.id] = item;
          }
        }
      }

      return results;
    },
    detail() {
      if (this.detailId) {
        return this.results[this.detailId];
      }
      return false;
    },
    sponsor() {
      var result = this.$store.getters["getSponsors"]("facility");
      return result || false;
    }
  },
  methods: {
    select(id) {
      this.$router.push({
        name: "facilities_detail",
        params: {
          id: id
        }
      });
      this.detailId = this.$route.params.id;
    },
    load() {
      if (this.$route.params.id) {
        this.detailId = this.$route.params.id;
      } else {
        this.detailId = false;
      }
    }
  },
  created() {},
  mounted() {
    this.load();
  },
  watch: {
    "$route.params": {
      handler: function(newValue, value) {
        this.load();
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.list {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: minmax(0, 1fr);

  .item {
    background-size: 15px;
    background-position: center right 10px;
    background-image: url("~@/../public/img/left_arrow.svg");
    background-repeat: no-repeat;
    background-color: #fff;
    border-radius: 4px;
    padding: 8px;
    border-radius: 4px;
    overflow: hidden;

    display: flex;
    flex-direction: row;

    .image {
      width: 60px;
      height: 60px;
      background-size: cover;
      //   display: inline-block;
      //   float: left;
      border-radius: 4px;
    }
    .content {
      //   width: calc(100% - 60px - 15px);
      //   display: inline-block;
      text-align: left;
      padding: 5px 10px;

      .title {
        font-family: $font-title;
        color: #222;
        font-size: 14px;
      }
      .city {
        margin-top: 0px;
        background-size: 20px;
        background-position: center left;
        background-image: url("~@/../public/img/marker.svg");
        background-repeat: no-repeat;
        font-size: 13px;
        padding: 5px 0;
        padding-left: 25px;
      }
    }
  }
}
.searcher {
  background-size: 20px;
  background-position: center right 10px;
  background-image: url("~@/../public/img/search.svg");
  background-repeat: no-repeat;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 15px;
  background-color: #fff;
  text-align: left;
  input {
    width: calc(100% - 30px);
    height: 40px;
    border: none;
    outline: none;
    padding: 10px;
    font-size: 18px;
  }
}

.tablet {
  .list {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
.laptop {
  .list {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
.desktop {
  .list {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
</style>
